import React from 'react';
import { Eyebrow, Section } from './Section';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <Section tone="creme" labelledBy="bonus-title" data-id="element-27" data-mp="pioawsk4rebp">
      <Eyebrow data-id="element-28" data-mp="avcxel4e1k8y">5 bonus inclus</Eyebrow>
      <h2 id="bonus-title" className="max-w-3xl font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.75rem]" data-id="element-29" data-mp="aua7ogisxnum">
        Cinq bonus pour passer à la pratique dès votre prochaine séance
      </h2>

      <ol className="mt-16 space-y-14" data-id="element-30" data-mp="1wrj525y8rdz">
        {bonuses.map((bonus, index) => <li key={bonus.number} className="grid grid-cols-1 items-center gap-8 border-t border-warm-line pt-10 md:grid-cols-12 md:gap-12" data-id="element-31" data-mp="5xbhg929e11p" data-mpi={index}>
            <div className={`md:col-span-5 ${index % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-32" data-mp="3t1hhumiel4ww">
              <img src={bonus.image} alt={bonus.alt} className="aspect-[4/5] w-full border border-warm-line bg-white object-cover shadow-paper" width={1200} height={1500} loading="lazy" data-id="element-33" data-mp="1m8fb98f3rvpf" />
            </div>

            <div className={`md:col-span-7 ${index % 2 === 1 ? 'md:order-1' : ''}`} data-id="element-34" data-mp="3r6i58udb197f">
              <div className="flex flex-wrap items-center gap-3" data-id="element-35" data-mp="3n5oiw5fig2gn">
                <p className="text-xs font-semibold uppercase tracking-[0.14em] text-warm" data-id="element-36" data-mp="2zf2csjp2gs9a">
                  {bonus.number}
                </p>
                <span aria-hidden="true" className="text-warm-line" data-id="element-37" data-mp="2uibt7me1zej4">
                  ·
                </span>
                <p className="text-xs font-semibold uppercase tracking-[0.14em] text-graphite" data-id="element-38" data-mp="38e5x1qzyzdpd">
                  Inclus
                </p>
              </div>
              <h3 className="mt-4 font-serif text-2xl font-semibold leading-snug text-graphite md:text-[1.75rem]" data-id="element-39" data-mp="nozvuihvvu4w">
                {bonus.title}
              </h3>
              <p className="mt-5 max-w-prose text-base leading-relaxed text-graphite-mid" data-id="element-40" data-mp="3cj6hkedz1spd">
                {bonus.body}
              </p>
              <p className="mt-5 text-sm text-warm" data-id="element-41" data-mp="3hgohxgdxazlr">{bonus.volume}</p>
            </div>
          </li>)}
      </ol>
    </Section>;
}